var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegisterDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2138 23.4302C22.0855 23.4119 21.9205 23.4119 21.7738 23.4302C18.5471 23.3202 15.9805 20.6802 15.9805 17.4352C15.9805 14.1169 18.6571 11.4219 21.9938 11.4219C25.3121 11.4219 28.0071 14.1169 28.0071 17.4352C27.9888 20.6802 25.4405 23.3202 22.2138 23.4302Z",
    fill: "#42398C",
    stroke: "#42398C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.354 35.5294C31.0906 38.5177 26.764 40.3327 21.9973 40.3327C17.2306 40.3327 12.904 38.5177 9.64062 35.5294C9.82396 33.806 10.924 32.1194 12.8856 30.7994C17.909 27.4627 26.1223 27.4627 31.109 30.7994C33.0706 32.1194 34.1706 33.806 34.354 35.5294Z",
    fill: "#42398C",
    stroke: "#42398C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9974 40.3327C32.1226 40.3327 40.3307 32.1246 40.3307 21.9993C40.3307 11.8741 32.1226 3.66602 21.9974 3.66602C11.8722 3.66602 3.66406 11.8741 3.66406 21.9993C3.66406 32.1246 11.8722 40.3327 21.9974 40.3327Z",
    stroke: "#42398C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisterDark);
export default __webpack_public_path__ + "static/media/registerDark.49ed4ce50d9e543f724426d1559b776f.svg";
export { ForwardRef as ReactComponent };